import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import API from './request/api'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/assets/css/global.css'
import _ from 'lodash'

Vue.config.productionTip = false

Vue.use(API)
Vue.use(Antd)
Vue.prototype._ = _

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
